<template>
  <div>
    <Modal width="450" v-model="show" title="导入花名册" :footer-hide="true">
      <Spin fix v-if="loading"></Spin>

      <!-- <div class="moban_div">
                注意：导入模板中入职时间请按【xxxx-xx-xx】格式填写！
            </div> -->
      <div class="moban_div">
        <span class="moban" @click="click_down_template">
          <Icon type="md-download" />下载导入模板
        </span>
      </div>
      <div class="upload_button">
        <Upload :action="upload_url" :on-success="success_upload" ref="upload">
          <Button icon="ios-cloud-upload-outline" style="font-size: 12px"
            >点击上传花名册文件</Button
          >
        </Upload>
      </div>
      <div class="upload_button_div">
        <Button type="primary" style="font-size: 12px" @click="click_import"
          >确认导入</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "import_hmc",
  data() {
    return {
      show: false,
      project_id: "",
      upload_url:
        process.env.VUE_APP_HOST +
        "/roster_manage/import/upload_xls?token=" +
        this.$cookies.get("dx_token"),
      upload_object: "",
      loading: false,
    };
  },

  methods: {
    click_import() {
      if (this.upload_object == "") {
        this.$Message.error("请先上传文件");
        return;
      }

      var that = this;
      var obj = {
        project_id: this.project_id,
        url: this.upload_object,
      };
      this.loading = true;
      http("post", process.env.VUE_APP_HOST + "/roster_manage/import/v1", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;

          console.log(res, "请求出错");
        });
    },

    success_upload(e) {
      console.log(e);
      if (e.code == 0) {
        var url = e.data.url;
        this.upload_object = url;
      } else {
        this.$refs.upload.clearFiles();
        this.$Message.error(e.msg);
      }
    },

    click_down_template() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/import/template_excel",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            open_new_page(res.data.url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open(project_id) {
      this.project_id = project_id;
      this.show = true;
    },
  },
};
</script>

<style scoped>
.upload_button_div {
  margin-top: 20px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}

.upload_button {
  display: flex;
  justify-content: center;
}

.moban_div {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ccc;
}

.moban {
  font-size: 13px;
  cursor: pointer;
  color: #0466dd;
}
</style>
